// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2SHg3","dragIcon":"Choice_dragIcon__2bcsh","left":"Choice_left__2GOl1","input":"Choice_input__mGpyZ"};